import { MatBottomSheetConfig } from '@angular/material/bottom-sheet';

export const bottomSheetDefaultConfig: MatBottomSheetConfig = {
  hasBackdrop: true,
  direction: 'ltr',
}
